export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Generate login URL at runtime so redirect URI reflects the current origin.
// Supports both Manus OAuth and Auth0 based on tenant configuration
export const getLoginUrl = (authProvider?: 'manus' | 'auth0', options?: { gymRegistration?: boolean }) => {
  // If Auth0 is configured, use Auth0 login endpoint
  if (authProvider === 'auth0') {
    const auth0Url = "/api/auth/login";
    if (options?.gymRegistration) {
      return `${auth0Url}?gymRegistration=true`;
    }
    return auth0Url;
  }
  
  // Default to Manus OAuth (only if variables are configured)
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  
  // If Manus OAuth variables are not configured, fallback to Auth0
  if (!oauthPortalUrl || !appId) {
    console.warn('[Auth] Manus OAuth variables not configured, falling back to Auth0');
    const auth0Url = "/api/auth/login";
    if (options?.gymRegistration) {
      return `${auth0Url}?gymRegistration=true`;
    }
    return auth0Url;
  }
  
  const redirectUri = `${window.location.origin}/api/oauth/callback`;
  // Encode state as JSON to include additional parameters
  const stateObj = {
    returnUrl: redirectUri,
    gymRegistration: options?.gymRegistration || false
  };
  const state = encodeURIComponent(JSON.stringify(stateObj));

  const url = new URL(`${oauthPortalUrl}/app-auth`);
  url.searchParams.set("appId", appId);
  url.searchParams.set("redirectUri", redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("type", "signIn");

  return url.toString();
};
